<mat-toolbar class="toolbar">
  <mat-grid-list cols="2" rowHeight="65px">
    <mat-grid-tile class="tileAlignmentStart">
      <img routerLink="/launchpad" src="../assets/allegion.svg" alt="allegion" width="35" />&nbsp;&nbsp;
      <a routerLink="/">Notification Preferences</a>
    </mat-grid-tile>
    <mat-grid-tile class="tileAlignmentEnd">
      <div class="profile-button" #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="appMenu">
        <div class="icon-container"><mat-icon class="material-icons-outlined"> account_circle </mat-icon></div>
      </div>
      <mat-menu #appMenu="matMenu" class="profile-menu">
        <div class="profile-header">
          <mat-icon class="material-icons-outlined"> account_circle </mat-icon>
          <span *ngIf="userProfile !== undefined">
            {{ userProfile.name }}
          </span>
        </div>
        <div class="notice" (click)="OnClickShowThirdPartyNotice()">
          <mat-icon>description</mat-icon>
          <span>Third party notices</span>
        </div>
        <div class="logout-div" (click)="openLogoutDialog($event)">
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </div>
      </mat-menu>
    </mat-grid-tile>
  </mat-grid-list>
</mat-toolbar>